<template lang="html">
    <div>
        <h6> Meer artikelen </h6>
        <ul>
            <router-link to="/artikelen/quantum-mechanica">
                <li>Quantum Mechanica</li>
            </router-link>
            <!-- <router-link to="/artikelen/de-reiger-en-corona">
                <li>De Reiger en Corona</li>
            </router-link> -->
            <router-link to="/artikelen/singularity">
                <li>Singulariteit</li>
            </router-link>
            <router-link to="/artikelen/doe-niet-mee">
                <li>Doe niet mee</li>
            </router-link>
            <router-link to="/artikelen/oplopende-gemoederen">
                <li>Oplopende gemoederen</li>
            </router-link>
            <router-link to="/artikelen/de-poortwachter">
                <li>De Poortwachter</li>
            </router-link>
            <router-link to="/artikelen/boosheid">
                <li>Boosheid</li>
            </router-link>
            <router-link to="/artikelen/vrijheid-van-denken">
                <li>Vrijheid van Denken</li>
            </router-link>
            <router-link to="/artikelen/openheid">
                <li>Openheid</li>
            </router-link>
            <router-link to="/artikelen/zoektocht">
                <li>Zoektocht</li>
            </router-link>
            <router-link to="/artikelen/parels-voor-de-zwijnen">
                <li>Parels voor de zwijnen</li>
            </router-link>
            <router-link to="/artikelen/rol-van-rituelen">
                <li>De rol van rituelen</li>
            </router-link>
            <router-link to="/artikelen/waar-de-vriendschap-woont">
                <li>Waar de vriendschap woont</li>
            </router-link>
            <router-link to="/artikelen/oog-van-de-naald">
                <li>Oog van de naald</li>
            </router-link>
            <router-link to="/artikelen/malende-molens">
                <li>Malende Molens</li>
            </router-link>
            <router-link to="/artikelen/broederschap">
                <li>Broederschap</li>
            </router-link>
            <router-link to="/artikelen/de-moderne-vrijmetselarij">
                <li>De moderne Vrijmetselarij</li>
            </router-link>
            <router-link to="/artikelen/lid-worden">
                <li>Lid worden</li>
            </router-link>
            <router-link to="/artikelen/symboliek">
                <li>Symboliek</li>
            </router-link>
        </ul>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
ul {
    /* margin: 0; */
    /* padding: 0; */
    /* list-style-type: none; */
}
li {
    color: white;
    font-size: 19px;
}
</style>
